import { render, staticRenderFns } from "./withdrawliushuiHistory.vue?vue&type=template&id=6c199f37&scoped=true"
import script from "./withdrawliushuiHistory.vue?vue&type=script&lang=js"
export * from "./withdrawliushuiHistory.vue?vue&type=script&lang=js"
import style0 from "./withdrawliushuiHistory.vue?vue&type=style&index=0&id=6c199f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c199f37",
  null
  
)

export default component.exports